import React from "react";
import { func, array } from "prop-types";
import { CO_BRANDED_RESEARCH } from "../partnered-data";
import { CoBrandedSlider } from "../co-branded-slider";
import "./co-branded-research-section.m.css";

export const CoBrandedResearchSection = ({ stories, onPartnerFormOpen }) => {
  return (
    <section id="co-branded-research" styleName="co-branded-section">
      <div styleName="centered">
        <div styleName="content-container">
          <p styleName="research-eyebrow">{CO_BRANDED_RESEARCH.eyebrow}</p>
          <h2 styleName="research-headline">{CO_BRANDED_RESEARCH.headline}</h2>
          <div styleName="research-separator" />
          <p styleName="co-branded-description">
            <span styleName="co-branded-highlight">
              {CO_BRANDED_RESEARCH.highlight}
            </span>{" "}
            {CO_BRANDED_RESEARCH.text}
          </p>
          <CoBrandedSlider
            stories={stories}
            sliderLabel={CO_BRANDED_RESEARCH.sliderLabel}
          />
          <button
            styleName="research-button"
            onClick={() => onPartnerFormOpen("Collaborate on Research")}
          >
            {CO_BRANDED_RESEARCH.cta}
          </button>
        </div>
      </div>
    </section>
  );
};

CoBrandedResearchSection.propTypes = {
  stories: array,
  onPartnerFormOpen: func.isRequired,
};
